import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BusinessIcon from '@mui/icons-material/Business';
import './RoleSelectionModal.scss';

function RoleSelectionModal({ open, onClose, onSelectRole }) {
  const handleKeyPress = (event, role) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelectRole(role);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="role-selection-modal"
      className="role-selection-modal"
      disableEnforceFocus
      disableAutoFocus
    >
      <Box className="modal-content">
        <Typography variant="h4" className="modal-title">
          Choose Your Portal
        </Typography>
        <Typography variant="body1" className="modal-subtitle">
          You have access to multiple portals. Please select where you want to continue:
        </Typography>
        
        <div className="role-options">
          <Button
            className="role-option admin-option"
            onClick={() => onSelectRole('initio-admins')}
            onKeyPress={(e) => handleKeyPress(e, 'initio-admins')}
            role="button"
            tabIndex={0}
          >
            <div className="role-icon">
              <AdminPanelSettingsIcon />
            </div>
            <Typography variant="h5">Admin Portal</Typography>
            <Typography variant="body2">
              Manage system settings, users, and administrative controls
            </Typography>
          </Button>

          <Button
            className="role-option enterprise-option"
            onClick={() => onSelectRole('enterprise-users')}
            onKeyPress={(e) => handleKeyPress(e, 'enterprise-users')}
            role="button"
            tabIndex={0}
          >
            <div className="role-icon">
              <BusinessIcon />
            </div>
            <Typography variant="h5">Enterprise Portal</Typography>
            <Typography variant="body2">
              Access business tools and enterprise features
            </Typography>
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default RoleSelectionModal; 